<template>
  <div class="main-layout mx-auto">
    <nav
      class="sticky w-full mx-auto z-20 top-0 left-0"
      :class="bgColor"
    >
      <div class="max-w-screen-xl mx-auto px-4 py-2">
        <slot name="nav" />
      </div>
    </nav>
    <main>
      <slot />
    </main>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useBasketStore } from '@/stores/basket';
import { useProductsStore } from '@/stores/products';
import { initAccordions } from 'flowbite';

const Products = computed(() => useProductsStore().FilteredData);

const {
  Load: LoadBasket,
} = useBasketStore();

const {
  Load: LoadProducts,
} = useProductsStore();

defineProps({
  bgColor: {
    type: String,
    default: 'bg-primary-600',
  },
});
onMounted(() => {
  initAccordions();
  LoadProducts();
  if (!Products.value.length) {
    LoadProducts();
  }
  LoadBasket({});
});
</script>
